import React from 'react';
import { 
  ResponsiveContainer, 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend,
  Cell
} from 'recharts';

const QuickStats = ({ dashboardData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Estatísticas Rápidas</h2>
        <div className="h-64 bg-gray-100 rounded animate-pulse" />
      </div>
    );
  }

  // Prepare chart data from dashboard metrics
  const chartData = dashboardData ? [
    {
      name: 'Faturamento',
      value: dashboardData?.totalRevenue || 0,
      color: '#10b981'
    },
    {
      name: 'Pago Fornecedor',
      value: dashboardData?.totalPaidToSuppliers || 0,
      color: '#ef4444'
    },
    {
      name: 'Receita Líquida',
      value: dashboardData?.netProfit || 0,
      color: dashboardData?.netProfit > 0 ? '#10b981' : '#ef4444'
    },
    {
      name: 'A Pagar',
      value: dashboardData?.pendingPayables || 0,
      color: '#f59e0b'
    },
    {
      name: 'A Receber',
      value: dashboardData?.pendingReceivables || 0,
      color: '#3b82f6'
    }
  ] : [];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(value);
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length > 0) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
          <p className="font-semibold text-gray-900">{payload?.[0]?.payload?.name}</p>
          <p className="text-lg font-bold" style={{ color: payload?.[0]?.payload?.color }}>
            {formatCurrency(payload?.[0]?.value)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
      <h2 className="text-xl font-bold text-gray-900 mb-6">Estatísticas Rápidas</h2>
      {!dashboardData || chartData?.length === 0 ? (
        <div className="h-64 flex items-center justify-center text-gray-500">
          <p>Sem dados disponíveis</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart 
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: '#6b7280', fontSize: 12 }}
              angle={-15}
              textAnchor="end"
              height={70}
            />
            <YAxis 
              tick={{ fill: '#6b7280', fontSize: 12 }}
              tickFormatter={formatCurrency}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="value" 
              name="Valor (R$)"
              radius={[8, 8, 0, 0]}
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default QuickStats;